/**
 * @fileoverview Shared constants for QMA / comps-agent pipeline and Quick Market Analysis UI.
 * @module constants/qmaPipelineConstants
 */

export const REPORT_STATUS_INITIAL = "initial";
export const REPORT_STATUS_PROCESSING = "processing";
export const REPORT_STATUS_FINAL = "final";

export const PRICE_MIN_MULTIPLIER = 0.95;
export const PRICE_MAX_MULTIPLIER = 1.05;

/** Default for comps-agent and QMA GraphQL subscriptions (parity with legacy PropertyDetails bar). */
export const SUBSCRIPTION_TIMEOUT_MS = 5 * 60 * 1000;
